export default "<div>\n  <div scrollX=\"true\" class=\"slider-track pb-4 -mb-4\">\n    <ng-content></ng-content>\n  </div>\n</div>\n";